<template>
    <main class="organization-profile">
        <div class="search-block">
            <div class="worker-header">
                <div class="hitem">
                    <div class="hinputs">
                        <!--<input autocomplete="off" placeholder="Поиск поставщика" @keyup="getContracts()" v-model="search">
                        <img class="hover_btn" src="@/assets/img/worker/search.svg" alt="">-->
                    </div>
                    <app-button style="width: 360px;" class="ml-2" @click="$router.push({name: 'oadd'})">Добавить договор</app-button>
                </div>
            </div>
        </div>
        <div class="row">
            <app-checkbox class="col-4" v-model="no_active">Не показывать неактивные договоры</app-checkbox>
            <app-checkbox class="col-4" v-model="is_favorites">Отображения только избранных</app-checkbox>
        </div>
        <br>
        <div class="filter-selects-block">
            <div class="filter-block">
                <div class="input-block">
                    <h4>Мое юр. лицо</h4>
                    <app-select :options="entities" :search="true" @input="filter()" v-model="entity" label="company_name" :placeholder="'Мое юр. лицо'"/>
                </div>
                <div class="input-block">
                    <h4>Юр. лицо партнера</h4>
                    <app-select :options="partner_entities" :search="true" @input="filter()" v-model="entity_partner" label="company_name" :placeholder="'Юр. лицо партнера'"/>
                </div>
            </div>
        </div>
        <loading-container :loading="loading" height="99">
            <table>
                <tr>
                    <th>ID</th>
                    <th>
                        <div class="contract-buttons-container">
                            Мое юр лицо
                            <div class="contract-buttons">
                                <svg width="10" height="6" class="contract-button cp" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" @click="changeOrder('entity_asc')" :class="{active: order == 'entity_asc'}">
                                    <path d="M5.70711 0.707106L9.29289 4.29289C9.92286 4.92286 9.47669 6 8.58579 6L1.41421 6C0.523309 6 0.0771428 4.92286 0.707108 4.29289L4.29289 0.707106C4.68342 0.316582 5.31658 0.316582 5.70711 0.707106Z" fill="#B6BCC8"/>
                                </svg>
                                <svg width="10" class="cp" style="transform: rotate(180deg)" height="6" viewBox="0 0 10 6" fill="none" @click="changeOrder('entity_desc')" :class="{active: order == 'entity_desc'}" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.70711 0.707106L9.29289 4.29289C9.92286 4.92286 9.47669 6 8.58579 6L1.41421 6C0.523309 6 0.0771428 4.92286 0.707108 4.29289L4.29289 0.707106C4.68342 0.316582 5.31658 0.316582 5.70711 0.707106Z" fill="#B6BCC8"/>
                                </svg>
                            </div>
                        </div>
                    </th>
                    <th>
                        <div class="contract-buttons-container">
                            Юр лицо партнера
                            <div class="contract-buttons">
                                <svg width="10" height="6" class="contract-button cp" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" @click="changeOrder('entity_partner_asc')" :class="{active: order == 'entity_partner_asc'}">
                                    <path d="M5.70711 0.707106L9.29289 4.29289C9.92286 4.92286 9.47669 6 8.58579 6L1.41421 6C0.523309 6 0.0771428 4.92286 0.707108 4.29289L4.29289 0.707106C4.68342 0.316582 5.31658 0.316582 5.70711 0.707106Z" fill="#B6BCC8"/>
                                </svg>
                                <svg width="10" class="cp" style="transform: rotate(180deg)" height="6" viewBox="0 0 10 6" fill="none" @click="changeOrder('entity_partner_desc')" :class="{active: order == 'entity_partner_desc'}" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.70711 0.707106L9.29289 4.29289C9.92286 4.92286 9.47669 6 8.58579 6L1.41421 6C0.523309 6 0.0771428 4.92286 0.707108 4.29289L4.29289 0.707106C4.68342 0.316582 5.31658 0.316582 5.70711 0.707106Z" fill="#B6BCC8"/>
                                </svg>
                            </div>
                        </div>
                    </th>
                    <th>
                        <div class="contract-buttons-container">
                          Клиент-закупщик
                            <div class="contract-buttons">
                                <svg width="10" height="6" class="contract-button cp" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" @click="changeOrder('entity_partner_asc')" :class="{active: order == 'entity_partner_asc'}">
                                    <path d="M5.70711 0.707106L9.29289 4.29289C9.92286 4.92286 9.47669 6 8.58579 6L1.41421 6C0.523309 6 0.0771428 4.92286 0.707108 4.29289L4.29289 0.707106C4.68342 0.316582 5.31658 0.316582 5.70711 0.707106Z" fill="#B6BCC8"/>
                                </svg>
                                <svg width="10" class="cp" style="transform: rotate(180deg)" height="6" viewBox="0 0 10 6" fill="none" @click="changeOrder('entity_partner_desc')" :class="{active: order == 'entity_partner_desc'}" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.70711 0.707106L9.29289 4.29289C9.92286 4.92286 9.47669 6 8.58579 6L1.41421 6C0.523309 6 0.0771428 4.92286 0.707108 4.29289L4.29289 0.707106C4.68342 0.316582 5.31658 0.316582 5.70711 0.707106Z" fill="#B6BCC8"/>
                                </svg>
                            </div>
                        </div>
                    </th>
                    <th>Договор</th>
                    <th>
                        <div class="contract-buttons-container">
                            Срок действия
                            <div class="contract-buttons">
                                <svg width="10" height="6" class="contract-button cp" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" @click="changeOrder('date_asc')" :class="{active: order == 'date_asc'}">
                                    <path d="M5.70711 0.707106L9.29289 4.29289C9.92286 4.92286 9.47669 6 8.58579 6L1.41421 6C0.523309 6 0.0771428 4.92286 0.707108 4.29289L4.29289 0.707106C4.68342 0.316582 5.31658 0.316582 5.70711 0.707106Z" fill="#B6BCC8"/>
                                </svg>
                                <svg width="10" class="cp" style="transform: rotate(180deg)" height="6" viewBox="0 0 10 6" fill="none" @click="changeOrder('date_desc')" :class="{active: order == 'date_desc'}" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.70711 0.707106L9.29289 4.29289C9.92286 4.92286 9.47669 6 8.58579 6L1.41421 6C0.523309 6 0.0771428 4.92286 0.707108 4.29289L4.29289 0.707106C4.68342 0.316582 5.31658 0.316582 5.70711 0.707106Z" fill="#B6BCC8"/>
                                </svg>
                            </div>
                        </div>
                    </th>
                    <th>Статус</th>
                    <th>Избранный</th>
                    <th style="padding: 0; width: 20px; background-color: white;"></th>
                </tr>
                <tr v-for="(contract, index) in contracts" :key="contract.id" class="tc">
                    <td>{{(page * 30 - 30) + index+1}}</td>
                    <td>
                        {{contract.entity ? contract.entity.company_name : ''}}
                    </td>
                    <td>
                        <router-link class="links_color" :to="contract.entity_provider ? ('/entity/' + contract.entity_provider.id) : ''">
                            {{contract.entity_provider ? contract.entity_provider.company_name : ''}}
                        </router-link>
                    </td>
                  <td>
                    {{contract.purchaser.name}}
                  </td>
                    <td><router-link class="pointer links_color" :to="'/contract/history/' + contract.id">{{contract.number}}</router-link></td>
                    <td><router-link class="pointer links_color" :to="'/contract/history/' + contract.id">{{contract.indefinitely ? 'Бессрочно' : contract.date_end}}</router-link></td>
                    <td :class="{active: contract.status == 'Действует'}">
                      {{contract.status}}
                    </td>
                    <td style="position: relative">
                      <app-checkbox  :value="contract.favorites" @input="changeFavorites($event, contract.id)"></app-checkbox>
                      <suppliers-menu
                        :ref="`menu${contract.id}`"
                        :item="contract"
                        :canChange="type != contract.initiator ? true : false"
                        @setParams="$refs.paramsDiag.open(contract)"
                        @setCancelParams="$refs.cancelDiag.open(contract)"
                        @reload="getContracts()"
                        :contract="true"
                      />
                    </td>
                    <td class="dots" @click="openMenu(contract.id)">
                      <img src="@/assets/icons/dots.svg" alt="">
                    </td>
                </tr>
            </table>
          <params-suppliers-modal :edit_contract="true" @saved="getContracts()" ref="paramsDiag"/>
          <change-contract-modal :key="2" ref="cancelDiag" @getContracts="getContracts"/>
        </loading-container>
        <div class="pagination-block">
          <pagination
            v-show="last_page > 1"
            v-model="page"
            :page-count="last_page"
            :click-handler="getContracts"
          />
        </div>
    </main>
</template>

<script>
import LoadingContainer from "@/components/loading-container";
import SuppliersMenu from "@/pages/organization/suppliers/suppliers-menu";
import ParamsSuppliersModal from "@/components/modals/params-suppliers-modal";
import ChangeContractModal from "@/components/modals/change-contract-modal";
import AppCheckbox from "@/components/app-checkbox";
import AppButton from "@/components/app-button";
import Pagination from "@/components/pagination";
import AppSelect from "@/components/app-select";

export default {
    name: "suppliers",
    data: function () {
        return {
            search: '',
            menus:[],
            loading: true,
            contracts: [],
            type: '',
            no_active: false,
            is_favorites: false,
            selected: '',
            page: 1,
            last_page: 0,
            entities: [],
            partner_entities: [],
            entity: '',
            entity_partner: '',
            order: ''
        }
    },
    mounted() {
      this.type = localStorage.getItem('type');
      this.getContracts();
      this.getEntities();
    },
    methods: {
      changeFavorites(status, contract_id){
        if (localStorage.getItem('token')) {
          this.$http.post('/change-favorites-contracts', {
            token: localStorage.getItem('token'),
            favorites: status,
            contract_id: contract_id
          })
              .then(({data}) => {
                if (data.status){
                  this.getContracts();
                }
              })
              .catch((error) => {
                console.log(error)
              });
        }
      },
      openMenu(val) {
        for (const key in this.contracts) {
            this.$refs['menu'+ this.contracts[key].id][0].close();
        }
        if (this.selected != val) {
          this.selected = val;
          this.$refs['menu'+ val][0].open();
        } else {
          this.selected = '';
        }

      },
      changeOrder(val)
      {
        this.page = 1;
        this.order = val;
        this.getContracts();
      },
      filter() {
        this.page = 1;
        this.getContracts();
      },
      getEntities() {
        if (localStorage.getItem('token')) {
          this.$http.post('/get-contracts-entities-filter', {
            token: localStorage.getItem('token'),
          })
          .then(({data}) => {
            if (data.entities) {
              this.entities = data.entities;
              this.entities.unshift({
                company_name: 'Все',
                id: ''
              });
            }
            if (data.partner_entities) {
              this.partner_entities = data.partner_entities;
              this.partner_entities.unshift({
                company_name: 'Все',
                id: ''
              });
            }
          })
          .catch((error) => {
            console.log(error)
          })
        }
      },
      getContracts() {
        if (localStorage.getItem('token')) {
          this.loading = true;
          this.$http.post('/get-contracts', {
            token: localStorage.getItem('token'),
            search: this.search,
            no_active: this.no_active ? 1 : 0,
            is_favorites: this.is_favorites ? 1 : 0,
            page: this.page,
            entity: this.entity ? this.entity.id : '',
            entity_partner: this.entity_partner ? this.entity_partner.id : '',
            order: this.order
          })
            .then(({data}) => {
              if (data.contracts) {
                this.contracts = data.contracts.data;
                this.last_page = data.contracts.last_page;
              }
            })
            .catch((error) => {
              console.log(error)
            })
            .finally(()=> this.loading = false)
        }
      },
    },
    watch: {
       no_active: function() {
           this.getContracts();
       },
       is_favorites: function() {
           this.getContracts();
       }
    },
    components: {
      AppButton,
      AppCheckbox,
      ParamsSuppliersModal,
      SuppliersMenu,
      LoadingContainer,
      ChangeContractModal,
      Pagination,
      AppSelect
    }
}
</script>

<style scoped lang="scss">
.cp {
  cursor: pointer;
}
.contract-buttons svg path {
  fill: rgba(225,225,225, 0.6);
}

.contract-buttons svg:hover path {
  fill: rgb(182, 188, 200);
}

.contract-buttons .active path {
  fill: rgb(182, 188, 200);
}

.contract-button {
  margin-top: 6px;
}
.contract-buttons-container {
  position: relative;
}
.contract-buttons {
  width: 10px;
  position: absolute;
  right: -6px;
  top: -10px;
}
.filter-selects-block {
    position: relative;
    height: 70px;
}

.filter-block {
  position: absolute;
  top: -21px;
  left: -36px;
}

.filter-block .input-block {
    float: left;
    width: 246px;
    margin-left: 20px;
}

.filter-block .input-block h4 {
    font-size: 12px;
    color: #7A818F;
}
.pagination-block {
    margin-top: 30px;
}

table tr:nth-child(even) {
  background: unset;
}
.dots {
    border-top: none !important;
}
table tr{
  border-bottom: 1px solid #a3a3a3 ;
}
.tc:hover .dots, .tc:hover {
  opacity: 1;
  background: #F9F9FB;
}
.search-block {
    position: absolute;
    top: 0px;
    right: 32px;
}
.organization-profile {
    position: relative;
}
.dots{
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  width: 20px;
}
main {
    margin-top: 32px;
    margin-left: 32px;
}
.organization-profile {
    width: 100%;
    padding: 0 30px;

    .active {
        color: #2CB181;
        font-weight: 500;
    }
}

.worker {
    position: relative !important;

    &-header {
         display: flex;
         justify-content: space-between;
         align-items: center;
         margin-bottom: 16px;

        .hitem{
            width: 100%;
            display: flex;
            align-items: center;
        }

        .hinputs {
            width: 100%;
            position: relative;
            display: flex;
            align-items: center;
            margin: 0;
            div {
                width: 100%;
            }

            input {
                border: 1px solid #EEF0F3;
                box-sizing: border-box;
                border-radius: 4px;
                font-size: 12px;
                width: 100%;
                height: 40px;
                padding: 0 40px 0 15px;
                outline: none;
            }

            > img {
                  position: absolute;
                  right: 15px;
                  bottom: 50%;
                  transform: translateY(50%);
                  width: 14px;
                  height: 14px;
            }

        }
    }
}
.links_color{
  color: #2CB181;
}
</style>
